import React from "react";

import { IMG_SETTING } from "../../../../../../../config/config.sna";

export const imageResolutionOpts = [
  {
    label: "low",
    value: "1",
  },
  {
    label: "normal",
    value: "3",
  },
  {
    label: "high",
    value: "5",
  },
];

export const imageMineTypeOpts = [
  {
    label: IMG_SETTING.jpg.name,
    value: IMG_SETTING.jpg.name,
  },
  {
    label: IMG_SETTING.png.name,
    value: IMG_SETTING.png.name,
  },
];

export const FILE_MINE_TYPE_KEY = {
  relationMatrix: "relationMatrix",
  meetCount: "meetCount",
  gephi: "gephi",
};

export const fileMineTypeOpts = [
  {
    label: "關係矩陣(.csv)",
    value: "relationMatrix",
  },
  {
    label: "見面次數(.csv)",
    value: "meetCount",
  },
  {
    label: "Gephi(.gexf)",
    value: "gephi",
  },
];
